import * as React from "react";
const SvgFiRrLocationCrosshairsSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-location-crosshairs-slash_svg__a)">
      <path
        fill="#062147"
        d="M15.943 20.154a1 1 0 0 1-.61 1.276 9.9 9.9 0 0 1-2.333.516V23a1 1 0 1 1-2 0v-1.058a10.04 10.04 0 0 1-6.07-2.87 10.04 10.04 0 0 1-2.872-6.072H1a1 1 0 1 1 0-2h1.053c.077-.787.247-1.57.516-2.333a1 1 0 1 1 1.885.666 8.05 8.05 0 0 0 1.888 8.324 8.04 8.04 0 0 0 8.324 1.887 1.003 1.003 0 0 1 1.275.61zm-5.193-3.312q.126.031.25.031a1 1 0 0 0 .25-1.969 3.01 3.01 0 0 1-2.156-2.154 1 1 0 1 0-1.936.498 5.01 5.01 0 0 0 3.592 3.594m12.957 5.45a.999.999 0 1 1-1.414 1.414l-4.626-4.626-.01-.009-.009-.01-9.174-9.173-.01-.009-.009-.01L.293 1.707A.999.999 0 1 1 1.707.293l3.964 3.964a9.9 9.9 0 0 1 5.33-2.208V1a1 1 0 1 1 2 0v1.05a9.92 9.92 0 0 1 6.07 2.88 9.92 9.92 0 0 1 2.88 6.07h1.05a1 1 0 1 1 0 2h-1.05a9.9 9.9 0 0 1-2.207 5.33l3.964 3.963M7.094 5.68l2.15 2.15a5.01 5.01 0 0 1 6.292.635A4.97 4.97 0 0 1 17 12a4.96 4.96 0 0 1-.828 2.758l2.148 2.148A7.94 7.94 0 0 0 20 12a7.95 7.95 0 0 0-2.343-5.657c-2.88-2.88-7.427-3.1-10.563-.663m7.614 7.614A3 3 0 0 0 15 12a2.98 2.98 0 0 0-.878-2.12 3 3 0 0 0-3.414-.587z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-location-crosshairs-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLocationCrosshairsSlash;
